<template>
    <!-- Sidebar Menu -->
	<nav class="mt-2">
        <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
			<!-- Add icons to the links using the .nav-icon class
				with font-awesome or any other icon font library -->
			<li class="nav-header">Menu</li>
			<li class="nav-item">
				<router-link to="/dash" class="nav-link" data-widget="pushmenu" role="button">
					<i class="nav-icon">
						<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
							<g id="dashboard_icon" transform="translate(80 -157)">
								<path id="Union_3" data-name="Union 3" d="M-1561,16a2,2,0,0,1-2-2V5a2,2,0,0,1,2-2h7a2,2,0,0,1,2,2v9a2,2,0,0,1-2,2Zm13-11a2,2,0,0,1-2-2V-6a2,2,0,0,1,2-2h7a2,2,0,0,1,2,2V3a2,2,0,0,1-2,2Z" transform="translate(1483 165)" fill="#fff" opacity="0.6"/>
								<path id="Union_4" data-name="Union 4" d="M-1548,16a2,2,0,0,1-2-2V9a2,2,0,0,1,2-2h7a2,2,0,0,1,2,2v5a2,2,0,0,1-2,2Zm-13-15a2,2,0,0,1-2-2V-6a2,2,0,0,1,2-2h7a2,2,0,0,1,2,2v5a2,2,0,0,1-2,2Z" transform="translate(1483 165)" fill="#fff"/>
							</g>
						</svg>
					</i>
					<p>Dashboard</p>
				</router-link>
			</li>
			
			<li class="nav-item">
				<router-link to="/subscriptions" class="nav-link" data-widget="pushmenu" role="button">
					<i class="nav-icon">
						<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
							<g id="IB_icon" transform="translate(-33 -274)">
								<circle id="Ellipse_10" data-name="Ellipse 10" cx="12" cy="12" r="12" transform="translate(33 274)" fill="#1a1818" opacity="0.5"/>
								<path id="Icon_material-attach-money" data-name="Icon material-attach-money" d="M13.066,9.67C11.581,9.284,11.1,8.885,11.1,8.263c0-.713.661-1.211,1.767-1.211,1.165,0,1.6.556,1.636,1.374h1.446a2.609,2.609,0,0,0-2.1-2.493V4.5H11.888V5.914A2.554,2.554,0,0,0,9.6,8.276c0,1.512,1.25,2.264,3.076,2.7,1.636.393,1.963.969,1.963,1.577,0,.452-.321,1.171-1.767,1.171-1.348,0-1.878-.6-1.95-1.374H9.48a2.742,2.742,0,0,0,2.408,2.507v1.42h1.963V14.873c1.276-.242,2.291-.982,2.291-2.323C16.142,10.691,14.552,10.056,13.066,9.67Z" transform="translate(32.189 275.61)" fill="#1a1818"/>
							</g>
						</svg>
					</i>
					<p>My Subscriptions</p>
				</router-link>
			</li>
			<li class="nav-item">
				<router-link to="/my-products/robots" class="nav-link" data-widget="pushmenu" role="button">
					<i class="nav-icon">
						<svg xmlns="http://www.w3.org/2000/svg" width="24" height="16.874" viewBox="0 0 24 16.874">
							<g id="product_icon" transform="translate(-33 -279.236)">
								<path id="Icon_awesome-box-open" data-name="Icon awesome-box-open" d="M23.933,6.441,22,2.586a.612.612,0,0,0-.626-.334L12,3.449l3.439,5.7a.616.616,0,0,0,.694.274l7.421-2.119a.618.618,0,0,0,.382-.866ZM1.993,2.586.062,6.441A.611.611,0,0,0,.441,7.3L7.862,9.422a.616.616,0,0,0,.694-.274L12,3.449l-9.382-1.2a.613.613,0,0,0-.622.334Z" transform="translate(33.003 276.988)" fill="#1b1b1b"/>
								<path id="Icon_awesome-box-open-2" data-name="Icon awesome-box-open" d="M15.961,10.648a1.818,1.818,0,0,1-1.552-.877L12,5.774l-2.407,4a1.824,1.824,0,0,1-1.556.881,1.725,1.725,0,0,1-.5-.071L2.4,9.111v6.675a1.2,1.2,0,0,0,.907,1.162l8.107,2.029a2.438,2.438,0,0,0,1.162,0l8.114-2.029a1.2,1.2,0,0,0,.907-1.162V9.111L16.46,10.577A1.725,1.725,0,0,1,15.961,10.648Z" transform="translate(33.003 277.063)" fill="#1b1b1b" opacity="0.5"/>
							</g>
						</svg>
					</i>
					<p>Products</p>
				</router-link>
			</li>
			<li class="nav-item">
				<router-link to="/introduction-broker" class="nav-link" data-widget="pushmenu" role="button">
					<i class="nav-icon">
						<svg width="24" height="24" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path fill-rule="evenodd" clip-rule="evenodd" d="M19 19.0323C20.463 19.0323 21.866 18.4511 22.9005 17.4166C23.935 16.3821 24.5161 14.9791 24.5161 13.5161C24.5161 12.0532 23.935 10.6501 22.9005 9.61564C21.866 8.58116 20.463 8 19 8C17.537 8 16.134 8.58116 15.0995 9.61564C14.065 10.6501 13.4839 12.0532 13.4839 13.5161C13.4839 14.9791 14.065 16.3821 15.0995 17.4166C16.134 18.4511 17.537 19.0323 19 19.0323ZM30.9516 20.258C29.895 20.258 28.8817 19.8383 28.1346 19.0912C27.3875 18.3441 26.9677 17.3307 26.9677 16.2742C26.9677 15.2176 27.3875 14.2043 28.1346 13.4571C28.8817 12.71 29.895 12.2903 30.9516 12.2903C32.0082 12.2903 33.0215 12.71 33.7686 13.4571C34.5158 14.2043 34.9355 15.2176 34.9355 16.2742C34.9355 17.3307 34.5158 18.3441 33.7686 19.0912C33.0215 19.8383 32.0082 20.258 30.9516 20.258ZM9.86541 19.0912C9.11829 19.8383 8.10498 20.258 7.04839 20.258C5.9918 20.258 4.97849 19.8383 4.23137 19.0912C3.48425 18.3441 3.06452 17.3307 3.06452 16.2742C3.06452 15.2176 3.48425 14.2043 4.23137 13.4571C4.97849 12.71 5.9918 12.2903 7.04839 12.2903C8.10498 12.2903 9.11829 12.71 9.86541 13.4571C10.6125 14.2043 11.0323 15.2176 11.0323 16.2742C11.0323 17.3307 10.6125 18.3441 9.86541 19.0912Z" fill="#1A1818"/>
							<path fill-rule="evenodd" clip-rule="evenodd" d="M11.6452 30.0645C11.6452 30.0645 9.80646 30.0645 9.80646 28.2258C9.80646 26.3871 11.6452 20.871 19 20.871C26.3548 20.871 28.1936 26.3871 28.1936 28.2258C28.1936 30.0645 26.3548 30.0645 26.3548 30.0645H11.6452ZM29.7035 29.4516C29.9393 28.9542 30.0569 28.4088 30.0471 27.8582C30.0471 25.6991 28.9655 23.4763 26.9677 21.9307C27.9649 21.6229 29.0038 21.4724 30.0471 21.4846C36.4094 21.4846 38 26.2648 38 27.8582C38 29.4516 36.4094 29.4516 36.4094 29.4516H29.7035ZM7.9529 27.8582C7.94307 28.4088 8.06067 28.9542 8.29646 29.4516H1.59058C1.59058 29.4516 0 29.4516 0 27.8582C0 26.2648 1.59058 21.4846 7.9529 21.4846C8.99624 21.4724 10.0351 21.6229 11.0323 21.9307C9.03449 23.4763 7.9529 25.6991 7.9529 27.8582Z" fill="#1A1818" fill-opacity="0.5"/>
						</svg>
					</i>
					<p>Career</p>
				</router-link>
			</li>
			<li class="nav-item">
				<router-link to="/bank-account" class="nav-link" data-widget="pushmenu" role="button">
					<i class="nav-icon">
						<svg xmlns="http://www.w3.org/2000/svg" width="21.598" height="20.158" viewBox="0 0 21.598 20.158">
							<g id="bank_icon" transform="translate(-34.201 -459.949)">
								<path id="Icon_awesome-university" data-name="Icon awesome-university" d="M22.723,6.57v.72a.36.36,0,0,1-.36.36h-1.08v.54a.54.54,0,0,1-.54.54H3.1a.54.54,0,0,1-.54-.54v-.54H1.485a.36.36,0,0,1-.36-.36V6.57a.36.36,0,0,1,.222-.333l10.439-3.96a.36.36,0,0,1,.275,0L22.5,6.237A.36.36,0,0,1,22.723,6.57Zm-1.08,13.679H2.2a1.08,1.08,0,0,0-1.08,1.08v.72a.36.36,0,0,0,.36.36H22.363a.36.36,0,0,0,.36-.36v-.72A1.08,1.08,0,0,0,21.643,20.248Z" transform="translate(33.076 457.699)"/>
								<path id="Icon_awesome-university-2" data-name="Icon awesome-university" d="M4.725,9.449v8.639H3.1a.54.54,0,0,0-.54.54v.9H21.283v-.9a.54.54,0,0,0-.54-.54h-1.62V9.449h-2.88v8.639h-2.88V9.449h-2.88v8.639H7.6V9.449Z" transform="translate(33.076 457.699)" opacity="0.5"/>
							</g>
						</svg>
					</i>
					<p>Bank Account</p>
				</router-link>
			</li>
			<li class="nav-header">Account</li>
			<li class="nav-item">
				<router-link to="/profile" class="nav-link" data-widget="pushmenu" role="button">
					<i class="nav-icon">
						<svg xmlns="http://www.w3.org/2000/svg" width="20" height="23" viewBox="0 0 20 23">
							<g id="profile_icon" transform="translate(-35 -356)">
								<circle id="Ellipse_7" data-name="Ellipse 7" cx="6" cy="6" r="6" transform="translate(39 356)" fill="#1a1818"/>
								<path id="Rectangle_155" data-name="Rectangle 155" d="M5,0H15a5,5,0,0,1,5,5V6a3,3,0,0,1-3,3H3A3,3,0,0,1,0,6V5A5,5,0,0,1,5,0Z" transform="translate(35 370)" fill="#1a1818" opacity="0.5"/>
							</g>
						</svg>
					</i>
					<p>Profile</p>
				</router-link>
			</li>
			<li class="nav-item">
				<a class="nav-link" @click="logout()" data-widget="pushmenu" role="button">
					<svg xmlns="http://www.w3.org/2000/svg" width="18" height="13.721" viewBox="0 0 18 13.721">
						<g id="logout_icon" transform="translate(-33.932 -435.466)">
							<path id="Icon_awesome-sign-out-alt" data-name="Icon awesome-sign-out-alt" d="M19.178,11.963l-6,6a.859.859,0,0,1-1.465-.61V13.924H6.857A.855.855,0,0,1,6,13.07V9.641a.855.855,0,0,1,.857-.857h4.858V5.355a.859.859,0,0,1,1.465-.61l6,6A.864.864,0,0,1,19.178,11.963Z" transform="translate(32.505 430.971)" fill="#1a1818" opacity="0.5"/>
							<path id="Icon_awesome-sign-out-alt-2" data-name="Icon awesome-sign-out-alt" d="M6.858,17.785V16.357a.43.43,0,0,0-.428-.428h-3a1.143,1.143,0,0,1-1.143-1.141V7.929A1.143,1.143,0,0,1,3.429,6.786h3a.43.43,0,0,0,.43-.429V4.928a.43.43,0,0,0-.43-.428h-3A3.429,3.429,0,0,0,0,7.929v6.858a3.429,3.429,0,0,0,3.429,3.429h3a.43.43,0,0,0,.43-.431Z" transform="translate(33.932 430.97)" fill="#1a1818"/>
						</g>
					</svg>
					<p>Logout</p>
				</a>
			</li>
        </ul>
	</nav>
	<!-- /.sidebar-menu -->
	
</template>
<script>
import swal from 'sweetalert'

export default {    
	name: "SidebarMenu",
	data(){
		return{
			isShow: false,
			window: false
		}
	},
	watch(){
		if (window.innerWidth <= 768) {
			this.window = true
		}
	},
	methods:{
		logout(){
			swal("Are You Sure to Log Out?", '', "info", {
				buttons: ["Cancel", "Logout"]
			}).then((res) => {
				if(res) {
					this.$store.dispatch('auth/logout', {
				})
					this.$router.push('login')
				} else {
					if(swal.close()){
						console.log("Cancel")
					}
				}
			})
		
		},
		handleSidebar(){
			let w = window.innerWidth <= 768
			if (this.window) {
				let sidebar = document.getElementsByTagName('BODY')[0]
				// console.log(sidebar.classList[2] == 'sidebar-open');
				if (sidebar.classList[2] == 'sidebar-open' && w) {
					document.body.classList.remove('sidebar-open');
					document.body.classList.add('sidebar-closed');
					// console.log(sidebar.classList);
				}
			}
		}
	}
}
</script>
<style scoped>
.nav{
	padding-bottom: 20px;
}
.nav-sidebar .nav-header{
	text-transform: uppercase;
	font-weight: 700;
	font-size: 10pt;
	padding-left: 0;
	color: var(--grey);
}
.nav-sidebar li .nav-link .nav-icon svg path{
	fill: #000;
	transition: all 0.3s ease;
}
.nav-sidebar li p{
	padding-left: 10px;
	font-size: 16px !important;
}
.nav-sidebar li .nav-link{
	padding: 0.8rem 1rem;
	font-weight: 600;
	transition: all 0.3s ease;
}
.nav-sidebar li a.nav-link:hover .nav-icon svg path{
	fill: #000;
}
.nav-sidebar li .nav-link.router-link-exact-active{
	background: var(--red);
	color: white;
}
.nav-sidebar li .nav-link.router-link-exact-active .nav-icon svg path{
	fill: white;
}

.sidebar-menu li.active > a > .fa-angle-left,
.sidebar-menu li.active > a > .pull-right-container > .fa-angle-left {
	animation-name: rotate;
	animation-duration: 0.2s;
	animation-fill-mode: forwards;
}

.treeview-title {
	z-index: 1;
}


@keyframes rotate {
	0% {
		transform: rotate(0deg);
	}

	100% {
		transform: rotate(-90deg);
	}
}
</style>